import { useState } from 'react';

export default function Methodology() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const steps = [
    {
      number: '01',
      title: 'Discovery & Strategy',
      description: 'We begin with an in-depth consultation to understand your brand, goals, and audience. Our team analyzes your current performance and creates a comprehensive roadmap tailored to your unique vision.',
      color: '#9B5E6B'
    },
    {
      number: '02',
      title: 'Content Optimization',
      description: 'Our creative experts work with you to elevate your content quality, scheduling, and presentation. We implement proven strategies that maximize engagement and subscriber retention.',
      color: '#C77A5A'
    },
    {
      number: '03',
      title: 'Growth & Marketing',
      description: 'Through targeted campaigns, social media integration, and strategic promotions, we expand your reach and attract high-value subscribers who align with your brand.',
      color: '#F2A35E'
    },
    {
      number: '04',
      title: 'Analytics & Scaling',
      description: 'We continuously monitor performance metrics, identify opportunities, and refine strategies. As your account grows, we scale operations to maintain momentum and maximize revenue.',
      color: '#7B4A5A'
    }
  ];

  return (
    <section id="methodology" className="py-24 bg-white">
      <div className="flex flex-col lg:flex-row">
        <div className="lg:w-[30%] bg-[#F6C1A1] flex items-center justify-center py-16 lg:py-0">
          <div className="transform lg:rotate-0 rotate-0">
            <h2 className="text-3xl lg:text-4xl font-bold text-[#0F0F0F] tracking-wider lg:writing-mode-vertical lg:transform lg:-rotate-90 text-center lg:text-left">
              OUR PROCESS
            </h2>
          </div>
        </div>

        <div className="lg:w-[70%] bg-white py-16 px-6 lg:px-16">
          <div className="space-y-12 max-w-4xl">
            {steps.map((step, index) => (
              <div 
                key={index}
                className="relative pl-20 pb-12 border-b border-[#F6C1A1] last:border-b-0 transition-all duration-300"
                style={{
                  borderLeftWidth: hoveredIndex === index ? '4px' : '2px',
                  borderLeftColor: hoveredIndex === index ? step.color : 'transparent'
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div className="absolute left-0 top-0">
                  <span 
                    className="text-5xl font-serif font-bold bg-gradient-to-br from-[#F2A35E] to-[#F6C1A1] bg-clip-text text-transparent"
                  >
                    {step.number}
                  </span>
                </div>
                
                <div>
                  <h3 className="text-2xl font-bold text-[#0F0F0F] mb-4">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed text-base">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
